import { Link } from "react-router-dom";
import { GAME_CONFIG } from "@hitster/shared";
import type { ReactNode } from "react";
import { VolumeControl } from "./VolumeControl";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="px-6 py-4 flex items-center justify-between border-b border-violet-500/20">
        <Link to="/" className="cw-title text-2xl font-extrabold bg-gradient-to-r from-violet-400 via-blue-400 to-orange-400 bg-clip-text text-transparent">
          {GAME_CONFIG.name}
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <VolumeControl />
          <Link to="/admin" className="text-violet-300/70 hover:text-violet-200">Admin</Link>
        </nav>
      </header>

      <main className="flex-1 p-4 md:p-8">{children}</main>
    </div>
  );
}
